import { VSCAssetAudioData, WordBoundary } from 'js/types';

import { fetchWithReAuth } from '../../requestLimiter';

import { AppServiceResponse, getObject, getOptions, getServicesUrl, validateResponse } from './helpers';

import { appServices } from '.';

const baseUrl = getServicesUrl();

const wordBoundariesCache: Map<number, Promise<WordBoundary[]>> = new Map();

export async function wordBoundaries(assetId: number): Promise<WordBoundary[]> {
  // Return cached promise if request is already in progress
  if (wordBoundariesCache.has(assetId)) {
    return wordBoundariesCache.get(assetId)!;
  }

  const url = `${baseUrl}project-asset/${assetId}`;
  const options = getOptions('GET');

  // Create the promise and cache it before awaiting
  const promise = fetchWithReAuth(url, appServices.exchangeCognitoTokenForSparkolToken, options)
    .then(r => validateResponse<AppServiceResponse>(r as AppServiceResponse, `Error fetching your projects.`))
    .then(r => getObject<VSCAssetAudioData>(r))
    .then(asset => asset.wordBoundaries || []);

  wordBoundariesCache.set(assetId, promise);
  return promise;
}
